module.exports = __webpack_public_path__ + "static/media/10-aermel_schuhe.850369fb.jpg";